import { GetterTree } from 'vuex'
import { State } from '.'
import { IPartyStatement, IStatement, IParty, IShootoutStatement } from '@/interfaces'
import router from '@/router'
import mixins from '@/mixins'

const GlobalMixins = new mixins()

const getters: GetterTree<any, any> = {
	firstStatementDefaultIndex(state: State): number | false {
		return state.firstStatementDefaultIndex
	},
	statements(state: State): IStatement[] {
		const statements = GlobalMixins.rawStatements

		if (state.firstStatementDefaultIndex !== false) {
			const firstStatement = statements.splice(state.firstStatementDefaultIndex, 1)
			
			statements.unshift(firstStatement[0])
		}

		return statements
	},
	statement: (state: State, getters: any) => (statementIndex?: number): IStatement | IShootoutStatement => {
		let statement: any = false
		let statements = router.currentRoute.name === 'shootout-statement' ? getters.shootoutStatements() : getters.statements

		if (statementIndex && statementIndex <= statements.length) {
			statement = statements[(statementIndex - 1)]
		} else if (router.currentRoute.name === 'statement' || router.currentRoute.name === 'shootout-statement' || router.currentRoute.name === 'embed') {
			statement = statements[(JSON.parse(router.currentRoute.params.id) - 1)]
		}

		if (statement) {
			const parties = GlobalMixins.parties
				.filter(party => {
					if (!party.participates) return false

					if (router.currentRoute.name === 'shootout-statement') {
						return ((state.user.shootoutParties as [number, number]).indexOf(party.id) !== -1)
					}
					
					return true
				})
				.map(party => {
					const partyStatementPosition = (router.currentRoute.name === 'shootout-statement' ? (party.shootoutStatements as IPartyStatement[]) : (party.statements as IPartyStatement[]))
						.filter(partyStatement => {
							return statement.id === partyStatement.id
						})[0]

					return {
						name: party.name,
						fullName: party.fullName,
						logoIndex: party.logoIndex,
						statement: partyStatementPosition
					}
				})
				
			statement.parties = {
				agree: parties.filter(party => party.statement.position === 'agree'),
				neither: parties.filter(party => party.statement.position === 'neither'),
				disagree: parties.filter(party => party.statement.position === 'disagree'),
			}
		}

		return statement
	},
	user(state: State): State['user'] {
		return state.user
	},
	timeSpendMakingChoices(state: State): number {
		return state.timeSpendMakingChoices
	},
	showAnalyticsQuestion(state: State): boolean {
		if (state.seenAnalyticsQuestion) return false
		if (!GlobalMixins.config.settings.minimumTimeSpent) return false
		if (!GlobalMixins.dictionary.selectAnalytics.options || !(GlobalMixins.dictionary.selectAnalytics.options.sendAllChoices || GlobalMixins.dictionary.selectAnalytics.options.sendForAnalysis)) return false
		if (GlobalMixins.dictionary.selectAnalytics.options.sendAllChoices && (!GlobalMixins.config.settings.analytics || typeof GlobalMixins.config.settings.analytics.votematchID !== 'number')) return false
		if (GlobalMixins.dictionary.selectAnalytics.options.sendForAnalysis && (!GlobalMixins.config.settings.analytics || typeof GlobalMixins.config.settings.analytics.votematchID !== 'number' || !GlobalMixins.config.settings.analytics.templateVersion)) return false

		return true
	},
	showRoadrunnerError(state: State) {	
		if (!GlobalMixins.config.settings.minimumTimeSpent) return false

		return !(state.timeSpendMakingChoices > (GlobalMixins.config.settings.minimumTimeSpent * 10))
	},
	showPrivacyStatement(state: State): boolean {
		return (state.skippedStart && !state.seenPrivacyStatement)
	},
	direction(state: State): 'left' | 'right' {
		return state.direction
	},
	shootoutStatements: (state: State) => (_shootoutParties?: [number, number]): IShootoutStatement[] => {
		let shootoutParties: [number, number]

		if (!_shootoutParties || _shootoutParties.length !== 2) {
			if (!state.user.shootoutParties || state.user.shootoutParties.length !== 2) return []

			shootoutParties = state.user.shootoutParties
		} else {
			shootoutParties = _shootoutParties
		}

		if (GlobalMixins.config.shootouts && GlobalMixins.config.shootouts.length > 0) {
			// find preconfigured shootout for specified parties
			let configuredShootout: any = GlobalMixins.config.shootouts.find(shootout => {
				return shootout.parties.includes(shootoutParties[0]) && shootout.parties.includes(shootoutParties[1]);
			});
			// if preconfigured shootout exists, return statements
			if (configuredShootout) {
				let results: IShootoutStatement[] = []; 
				GlobalMixins.rawShootoutStatements.forEach(statement => {
					for (let i = 0; i < configuredShootout.statements.length; i++) {
						if (statement.id == configuredShootout.statements[i]) {
							results[i] = statement;
							break;
						}
					}
				});
				return results;
			}
		}



		const parties = GlobalMixins.parties.filter(party => {
			return (shootoutParties.indexOf(party.id) !== -1)
		})
		const closeStatements: IShootoutStatement[] = []
		const BigDiffStatements: IShootoutStatement[] = []
		
		GlobalMixins.rawShootoutStatements
			.filter(statement => {
				const partiesPositions = parties.map(party => {
					let partyOpinion: false | 'agree' | 'neither' | 'disagree' = false

					;(party.shootoutStatements as IPartyStatement[]).forEach(partyStatement => {
						if (partyStatement.id === statement.id) partyOpinion = partyStatement.position
					})

					return partyOpinion
				})

				if (!partiesPositions[0] || !partiesPositions[1]) return false
				if (partiesPositions[0] === partiesPositions[1]) return false

				return true
			})
			.forEach(statement => {
				const partiesPositions: ('agree' | 'neither' | 'disagree')[] = parties.map(party => {
					let partyOpinion: undefined | 'agree' | 'neither' | 'disagree' = undefined

					;(party.shootoutStatements as IPartyStatement[]).forEach(partyStatement => {
						if (partyStatement.id === statement.id) partyOpinion = partyStatement.position
					})

					return (partyOpinion as any)
				})

				if ((partiesPositions[0] === 'neither' || partiesPositions[1] === 'neither')) {
					closeStatements.push(statement)
				} else {
					BigDiffStatements.push(statement)
				}
			})

		let selectionStatements: IShootoutStatement[] = BigDiffStatements.concat(closeStatements)
			.slice(0, GlobalMixins.config.settings.shootoutStatementAmount)

		if (!(selectionStatements.length % 2)) {
			selectionStatements = selectionStatements.slice(0, (selectionStatements.length - 1))
		}
		if (GlobalMixins.config.settings.shootoutMinimumStatementAmount && selectionStatements.length < GlobalMixins.config.settings.shootoutMinimumStatementAmount) {
			return []
		}

		return selectionStatements
	},
	showShootoutResults(state: State): boolean {
		return state.showShootoutResults
	},
	savedResults(state: State): any {
		return state.savedResults
	}
}

export default getters
